"use client";

import { createContext, useContext } from "react";

/**
 * Hands `close` to the fallback of a lazily-loaded modal.
 *
 * `next/dynamic` renders its own Suspense boundary and only ever passes
 * `{ isLoading, pastDelay, error }` to the `loading` component, so a skeleton shown while the
 * chunk downloads has no way to receive the modal's `close` as a prop. Wrapping the dynamic
 * component in this provider puts it within reach, which keeps the close button on screen for
 * the whole open rather than having it appear once the chunk lands.
 */
const LazyModalCloseContext = createContext<() => void>(() => undefined);

export const LazyModalCloseProvider = LazyModalCloseContext.Provider;

export const useLazyModalClose = () => useContext(LazyModalCloseContext);
